import { StateCreator } from "zustand";
import { ViewStateSliceType } from "./viewState.type";
import { addToResetFnsSet } from "../store";

const sliceInitialState = {
  incidentReturnTo: null,
  drilldown: null,
  leavingForIncident: false,
  incidentListView: null,
  incidentListTab: null,
  gridViews: {},
};

const createViewStateSlice: StateCreator<ViewStateSliceType> = (set) => {
  const reset = () => set(sliceInitialState);
  addToResetFnsSet(reset);
  return {
    ...sliceInitialState,
    setDrilldown: (drilldown) => set({ drilldown }),
    setLeavingForIncident: (leavingForIncident) => set({ leavingForIncident }),
    markLeavingForIncident: () =>
      set((state) => ({
        leavingForIncident: true,
        drilldown: state.drilldown
          ? { ...state.drilldown, viaIncident: true }
          : null,
      })),
    setIncidentReturnTo: (incidentReturnTo) => set({ incidentReturnTo }),
    setIncidentListTab: (incidentListTab) => set({ incidentListTab }),
    setIncidentListView: (incidentListView) => set({ incidentListView }),
    setGridView: (key, view) =>
      set((state) => ({ gridViews: { ...state.gridViews, [key]: view } })),
    clearGridViewsWithPrefix: (prefix) =>
      set((state) => ({
        gridViews: Object.fromEntries(
          Object.entries(state.gridViews).filter(([k]) => !k.startsWith(prefix))
        ),
      })),
  };
};

export default createViewStateSlice;
